import { IThankyouMessage } from 'modules/specialist/dashboard/components/thank-you-message-panel/thank-you-modal/thank-you-modal';
import { api, VERSION, formatUrl } from './api';

interface IPerformanceResponse {
  thisMonthEarnings: number;
  liveCases: number;
  averageTurnAroundTime: number;
}

export const dashboardApi = api.injectEndpoints({
  endpoints: (build) => ({
    getDiscounts: build.query<any, any>({
      query: () => formatUrl(`/discounts`),
      providesTags: (result) =>
        // is result available?
        result
          ? // successful query
            [
              ...result.referrals.map(({ id }: { id: string }) => ({ type: 'Discounts', id } as const)),
              { type: 'Discounts', id: 'LIST' },
            ]
          : // an error occurred, but we still want to refetch this query when `{ type: 'Discounts', id: 'LIST' }` is invalidated
            [{ type: 'Discounts', id: 'LIST' }],
    }),
    updateDiscountConfirm: build.mutation<any, any>({
      query(body) {
        return {
          url: formatUrl(`/discounts/confirm`),
          method: 'PUT',
          body,
        };
      },
      invalidatesTags: [{ type: 'Discounts', id: 'LIST' }],
    }),
    getThankYouMessageForSpecialist: build.query<any, any>({
      query: () => formatUrl('/messages'),
    }),
    getThankYouMessageByCase: build.query<IThankyouMessage, any>({
      query: (caseId) => formatUrl(`/messages?case=${caseId}`),
    }),
    updateLastActiveHubspot: build.mutation<any, any>({
      query() {
        return {
          url: `/user/${VERSION}/profile/lastActive`,
          method: 'PUT',
          body: {},
        };
      },
    }),
    getAnalyticsReferralData: build.query<any, any>({
      query: () => formatUrl(`/analytics/referral`),
    }),
    getSpecialistPerformanceData: build.query<IPerformanceResponse, any>({
      query: () => formatUrl('/performance'),
    }),
  }),
});

export const {
  useGetDiscountsQuery,
  useUpdateDiscountConfirmMutation,
  useGetThankYouMessageForSpecialistQuery,
  useGetThankYouMessageByCaseQuery,
  useUpdateLastActiveHubspotMutation,
  useGetAnalyticsReferralDataQuery,
  useGetSpecialistPerformanceDataQuery,
} = dashboardApi;
